import { Button, Flex } from "@mantine/core";
import { OrderList } from "../OrderList/OrderList";
import { IconDownload, IconFileDownload } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import classes from "./ProfileContent.module.css";

export default function ProfileContent(): React.JSX.Element {
  const { t } = useTranslation("translation");
  return (
    <>
      <Flex
        className={classes.flexContainer}
        direction={{ base: 'column', sm: 'row' }}
        gap={{ base: 'sm', sm: 'lg' }}
        justify={{ sm: 'center' }}
      >
        <Button variant="gradient" component="a" href="https://accsolutions.de/academy/download.php?branch=release"
                gradient={{ from: "yellow", to: "#FEBF0E" }}
                size="md" className={classes.control}>{t("general.downloadAcademy")}<IconDownload /></Button>
        <Button variant="gradient" component="a" href="https://builds.dotnet.microsoft.com/dotnet/WindowsDesktop/9.0.5/windowsdesktop-runtime-9.0.5-win-x64.exe"
                gradient={{ from: "yellow", to: "#FEBF0E" }}
                size="md" className={classes.control}>{t("general.downloadNet")}<IconDownload /></Button>
        <Button variant="gradient" component="a" href="https://docs.google.com/document/d/1Rw487xMfj1UYqBxgWjr4UezDsgu6C5SmB9D0XU3h_ng/export?format=pdf"
                gradient={{ from: "yellow", to: "#FEBF0E" }}
                size="md" className={classes.control}>{t("general.downloadManual")}<IconFileDownload /></Button>
      </Flex>
      {process.env.NODE_ENV === 'development' ? (
        <></>
      ) : (
        <OrderList />
      )}
    </>
  );
}
